import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PageTransition — wraps route content in a subtle fade entrance.
 * Re-triggers on pathname change via the key prop.
 */
export function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="nuri-page-enter">
      {children}
    </div>
  );
}
